import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getEventsData(context) {
      const response = await Vue.axios.get(`${URL_API}event`);
      let data = response["data"];
      context.commit("updateEventsData", data);
      context.commit("updateFilteredEvents", data);
    },
    async createEventData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}event/store`, body, config);
      context.dispatch("getEventsData");
    },
    async pushEventData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}event/update`, body, config);
      context.dispatch("getEventsData");
    },
    async destroyEventData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}event/destroy`, body, config);
      context.dispatch("getEventsData");
    }
  },
  mutations: {
    updateEventsData(state, eventsData) {
      state.eventsData = eventsData;
    }
  },
  state: {
    eventsData: []
  },
  getters: {
    allEventsData(state) {
      return state.eventsData;
    }
  }
};
